(() => {
  const desktop = window.matchMedia('(min-width: 990px)');

  const closeAll = (except) => {
    document.querySelectorAll('.modern-mega-menu[open]').forEach((menu) => {
      if (menu !== except) {
        menu.removeAttribute('open');
        const summary = menu.querySelector('summary');
        if (summary) summary.setAttribute('aria-expanded', 'false');
      }
    });
  };

  const bindTcgSections = (details) => {
    if (!details.matches('.modern-mega-menu--other-tcgs')) return;
    const menu = details.querySelector('.tt-tcg-menu');
    if (!menu || menu.dataset.tcgReady === 'true') return;

    const panels = Array.from(menu.querySelectorAll('[data-tcg-panel]'));
    const sections = Array.from(menu.querySelectorAll('[data-tcg-section]')).map((button) => ({
      button,
      panel: panels.find((panel) => panel.id === button.getAttribute('aria-controls')),
    }));
    if (!sections.length || sections.some(({ panel }) => !panel)) return;

    const selectSection = (section) => {
      sections.forEach(({ button, panel }) => {
        const selected = button === section.button;
        button.setAttribute('aria-pressed', String(selected));
        panel.hidden = !selected;
      });
    };

    sections.forEach((section, index) => {
      const { button, panel } = section;
      button.addEventListener('click', () => selectSection(section));
      button.addEventListener('mouseenter', () => {
        if (!desktop.matches || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
        if (panels.some((item) => item.contains(document.activeElement))) return;
        selectSection(section);
      });
      button.addEventListener('keydown', (event) => {
        let next;
        if (event.key === 'ArrowDown') next = (index + 1) % sections.length;
        if (event.key === 'ArrowUp') next = (index - 1 + sections.length) % sections.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = sections.length - 1;
        if (next !== undefined) {
          event.preventDefault();
          selectSection(sections[next]);
          sections[next].button.focus();
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          selectSection(section);
          panel.querySelector('a[href]')?.focus();
        }
      });
    });

    selectSection(sections.find(({ button }) => button.getAttribute('aria-pressed') === 'true') || sections[0]);
    menu.dataset.tcgReady = 'true';
  };

  const bindMenus = () => {
    document.querySelectorAll('.modern-mega-menu').forEach((details) => {
      bindTcgSections(details);
      if (details.dataset.modernMenuBound === 'true') return;
      details.dataset.modernMenuBound = 'true';

      const host = details.closest('header-menu') || details.parentElement;
      const summary = details.querySelector('summary');
      let suppressSummaryFocus = false;

      const openMenu = () => {
        if (!desktop.matches) return;
        closeAll(details);
        details.setAttribute('open', '');
        if (summary) summary.setAttribute('aria-expanded', 'true');
      };

      let leaveTimer;
      const cancelPendingClose = () => {
        window.clearTimeout(leaveTimer);
        leaveTimer = undefined;
      };

      const closeMenu = () => {
        cancelPendingClose();
        if (!desktop.matches) return;
        details.removeAttribute('open');
        if (summary) summary.setAttribute('aria-expanded', 'false');
      };

      // Allow the pointer to cross tiny subpixel/header gaps without the
      // mega menu disappearing before the cursor reaches the dropdown.
      const queueClose = () => {
        cancelPendingClose();
        leaveTimer = window.setTimeout(() => {
          if (details.matches(':hover') || (details.contains(document.activeElement) && document.activeElement !== summary)) return;
          closeMenu();
        }, 260);
      };

      host.addEventListener('mouseenter', () => {
        cancelPendingClose();
        openMenu();
      });
      host.addEventListener('mouseleave', queueClose);
      details.querySelector('.modern-mega-menu__content')?.addEventListener('mouseenter', () => {
        cancelPendingClose();
        openMenu();
      });
      summary?.addEventListener('focus', () => {
        if (!suppressSummaryFocus) openMenu();
      });

      details.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          const isTcgMenu = details.matches('.modern-mega-menu--other-tcgs');
          if (isTcgMenu) {
            event.preventDefault();
            event.stopPropagation();
            suppressSummaryFocus = true;
          }
          closeMenu();
          summary?.focus();
          suppressSummaryFocus = false;
        }
      });
    });
  };

  document.addEventListener('DOMContentLoaded', bindMenus);
  document.addEventListener('shopify:section:load', bindMenus);
  document.addEventListener('click', (event) => {
    if (!event.target.closest('.header-mega-menu-block')) closeAll();
  });

  desktop.addEventListener?.('change', () => closeAll());
})();
